<script lang="ts" generics="T, R">
	import type { CarouselTypeOption } from "$lib/serv/vendor-integration/splide";
	import type { Cache } from "$lib/serv/core/cache";
	import type { Snippet } from "svelte";

	// @ts-ignore: Declare module manually for Flickity
	import type * as Flickity from "flickity";

	import CarouselV3 from "./CarouselV3.svelte";

	// import '../../../scss/component/carousel.scss';

	interface Options extends Flickity.Options { fade?: boolean }

	type Props = {
		cache: Cache<T>;
		type?: CarouselTypeOption;
		key?: (payload: T) => R[];
		uniqueKey?: ((item: R) => string|number) | undefined;
		options?: Options;
		resize?: () => void;
		id?: string;
		title?: Snippet;
		children: Snippet<[{
			item: R;
			index: number;
		}]>;
	}

	let {
		cache,
		type = 'aisle',
		key = (payload: T) => Array.isArray(payload) ? payload as R[] : Array(9) as R[],
		uniqueKey,
		options = {},
		resize = $bindable(() => {}),
		id,
		title,
		children
	}: Props = $props();

	
</script>

<CarouselV3 {cache} {type} {title} {children} {key} {uniqueKey} {id}></CarouselV3>
